export default "__VITE_ASSET__3LMhn35G__"